import * as IoC from 'inversify';
import { registerCommand } from '@/app/tracking/api';
import { CompleteInteractionCommandName } from '../api'
import { interactionCommonTrackingModule } from '../common/di'
//import { XApiCompleteInteractionCommandHandler } from './xapi-complete-interaction-command-handler'

const interactionTinCanTrackingModule = new IoC.ContainerModule((bind) => {
//  registerCommand(CompleteInteractionCommandName, XApiCompleteInteractionCommandHandler, bind);
})

export const interactionTinCanTrackingModules = [
  interactionCommonTrackingModule,
  interactionTinCanTrackingModule
]
